import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ProfileCropPage } from './profile-crop';


@NgModule({
  declarations: [
  //  ProfileCropPage,
  ],
  imports: [
    IonicPageModule.forChild(ProfileCropPage),

  ],
})
export class ProfileCropPageModule {}



// WEBPACK FOOTER //
// ./src/pages/profile-crop/profile-crop.module.ts